// Port of src/app/components/nav-bar/search/search-list-item/search-list-item.component.{ts,html}
// (mypart-search-list-item). The Angular .scss file was empty — no stylesheet.
// [imageLoader]/ngSrc → AppImage; [isEllipsis] → useIsEllipsis hook.
//
// The Angular usage put (click) + stopPropagation on the component host;
// here the parent passes onClick and the root div applies it (the caller
// stops propagation inside its handler).

import type { MouseEventHandler } from 'react';
import type { Artwork } from '../../interfaces/artwork';
import AppImage from '../../shared/components/AppImage';
import { useIsEllipsis } from '../../shared/hooks/useIsEllipsis';

export interface SearchListItemProps {
  artwork: Artwork;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export default function SearchListItem({ artwork, onClick }: SearchListItemProps) {
  const { ref: titleRef } = useIsEllipsis<HTMLSpanElement>();
  const { ref: artistRef } = useIsEllipsis<HTMLSpanElement>();

  return (
    <div onClick={onClick}
         className="flex items-center mb-2.5 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none
              focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700" role="status">
      <div className="flex items-center justify-center
              md:w-[64px] md:min-w-[64px] md:h-[64px]
              w-[48px] min-w-[48px] h-[48px]
              bg-gray-300 rounded dark:bg-gray-700">
        <AppImage alt={'Cover image for the song - ' + artwork.title + ', By - ' + artwork.artist}
                  src={artwork.coverUrl}
                  className="rounded"
                  height={42} width={64} />
      </div>
      <div className="w-full flex flex-col content-center ml-2">
        <span ref={titleRef} className="lg:text-lg text-base font-semibold ellipsis">{artwork.title}</span>
        <span ref={artistRef} className="lg:text-base text-sm text-gray-500 dark:text-gray-400 ellipsis">{artwork.artist}</span>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
